export default "__VITE_ASSET__5lr_OEfD__"